var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTigerExcited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_7106)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.039 312.713C102.039 315.029 79.1745 317.055 51.1008 317.055C23.0272 317.055 0.163086 315.173 0.163086 312.713C0.163086 310.253 23.0272 308.372 51.1008 308.372C79.1745 308.517 102.039 310.398 102.039 312.713Z",
    fill: "#E4CBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.575 308.517C259.464 308.517 316.932 305.537 316.932 301.861C316.932 298.184 259.464 295.204 188.575 295.204C117.685 295.204 60.2173 298.184 60.2173 301.861C60.2173 305.537 117.685 308.517 188.575 308.517Z",
    fill: "#E4CBD8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5744 293.322C54.5744 304.465 45.4577 313.581 34.3151 313.581C23.1724 313.581 12.0298 303.596 12.0298 292.454C12.0298 281.311 24.1854 270.458 35.328 270.458C46.4706 270.458 54.5744 282.179 54.5744 293.322Z",
    fill: "url(#paint0_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0795 309.818C23.0276 309.818 19.5546 308.66 17.0945 306.2C16.8051 305.911 16.8051 305.477 17.0945 305.187C17.3839 304.898 17.8181 304.898 18.1075 305.187C24.0406 310.686 33.7361 307.792 38.9456 305.621C50.0883 300.846 59.6391 292.019 59.7838 288.98C59.7838 288.256 59.4944 287.677 59.0603 287.243C57.7579 286.085 54.5743 286.23 53.5613 286.375C53.1272 286.375 52.8378 286.085 52.6931 285.796C52.6931 285.362 52.9825 285.072 53.2719 284.928C53.4166 284.928 57.7579 284.349 59.9285 286.23C60.7968 286.954 61.0862 287.822 61.0862 288.98C61.0862 293.321 49.9436 302.582 39.3798 306.924C34.8938 308.95 30.6972 309.818 27.0795 309.818Z",
    fill: "url(#paint1_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2354 306.924C35.473 306.924 30.987 306.345 25.1986 304.609C15.0689 301.57 10.0041 298.531 9.56996 295.347C9.28054 293.177 11.5959 291.874 11.5959 291.874C11.8853 291.729 12.3194 291.874 12.6089 292.164C12.7536 292.453 12.6089 292.887 12.3194 293.177C12.3194 293.177 10.8723 294.045 11.0171 295.347C11.1618 296.794 13.3324 299.688 25.6327 303.306C45.4579 309.239 52.1146 301.859 52.6934 299.688C52.8381 299.254 53.2722 299.11 53.5617 299.254C53.9958 299.399 54.1405 299.833 53.9958 300.123C54.1405 299.978 51.391 306.924 39.2354 306.924Z",
    fill: "url(#paint2_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1317 307.359C26.6457 307.359 21.2915 306.346 15.069 303.596C14.6348 303.452 14.4901 303.018 14.6348 302.584C14.7795 302.149 15.2137 302.005 15.6478 302.149C27.6587 307.359 37.7884 307.07 45.7474 300.992C54.1405 294.624 56.89 284.205 56.6006 282.324C55.877 277.115 53.8511 273.497 50.3781 271.471C44.1556 267.853 35.6177 271.037 35.6177 271.037C35.1836 271.182 34.8942 271.037 34.7495 270.603C34.6047 270.169 34.7495 269.879 35.1836 269.734C35.6177 269.59 44.445 266.261 51.2463 270.169C55.0088 272.339 57.3241 276.391 58.0477 282.035C58.4818 285.074 55.0088 295.782 46.6156 302.149C43.1426 304.899 38.0778 307.359 31.1317 307.359Z",
    fill: "url(#paint3_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9459 313.871C38.8012 313.871 38.5118 313.726 38.3671 313.581C38.0776 313.292 38.0776 312.858 38.5118 312.568C48.0626 304.465 47.0496 289.27 43.2872 278.562C40.9718 272.05 37.9329 268.143 36.3411 267.998C30.8422 267.853 27.3691 272.773 27.3691 272.918C27.0797 273.207 26.6456 273.352 26.3562 273.063C26.0668 272.773 25.922 272.339 26.2115 272.05C26.3562 271.76 29.9739 266.406 36.3411 266.551C39.38 266.695 42.7084 272.339 44.7343 277.983C48.6414 288.981 49.5097 305.043 39.5247 313.581C39.38 313.726 39.0906 313.871 38.9459 313.871Z",
    fill: "url(#paint4_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7744 309.24H47.6297C47.1956 309.095 47.0509 308.806 47.0509 308.371C50.2345 295.203 40.1048 276.535 34.027 274.075C27.8045 271.471 21.8714 276.246 21.8714 276.391C21.582 276.68 21.1479 276.535 20.8584 276.246C20.569 275.957 20.7137 275.522 21.0032 275.233C21.2926 274.944 27.6598 269.879 34.6058 272.773C41.8413 275.667 51.6816 295.348 48.498 308.806C48.3532 308.95 48.0638 309.24 47.7744 309.24Z",
    fill: "url(#paint5_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2595 319.512C45.8923 319.512 39.525 319.512 33.1578 319.368C0.164057 318.644 -0.270074 317.052 -0.414784 316.329C-0.414784 316.039 -0.559493 315.605 0.308764 315.171C5.66302 312.856 24.9094 311.119 25.7776 310.974C26.2118 310.974 26.5012 311.264 26.5012 311.698C26.5012 312.132 26.2118 312.422 25.7776 312.422C25.6329 312.422 8.26779 314.013 1.90057 316.039C10.4384 317.631 58.0479 319.078 91.6205 316.908C98.4218 316.473 101.895 316.184 103.776 315.895C103.487 315.895 103.197 315.75 102.908 315.75C87.4239 316.039 76.7154 315.75 75.7024 314.882L75.413 314.737V314.303C75.413 313.724 75.8471 313.145 77.1495 312.856C76.7154 312.711 76.2813 312.711 75.8471 312.566C73.9659 311.987 72.9529 311.264 72.6635 310.106C72.5188 309.383 72.6635 308.37 74.1106 307.212C77.4389 304.607 85.8321 302.437 92.7782 305.62C94.0805 306.199 95.6723 307.067 95.5276 308.514C95.2382 310.396 91.4758 311.409 85.2533 312.711C87.7133 313 90.1734 313.29 92.6334 313.435C97.5536 313.869 100.737 314.303 102.763 314.592C124.904 314.158 158.187 312.711 191.325 309.961C223.451 307.212 259.484 305.765 281.479 306.344C284.952 304.752 287.991 303.015 290.307 300.845C296.674 294.912 297.253 292.017 296.674 290.715C295.227 287.676 286.4 288.255 283.216 288.834C282.782 288.834 282.492 288.689 282.348 288.255C282.348 287.821 282.492 287.531 282.926 287.387C284.229 287.242 295.661 285.506 297.832 290.136C299.134 292.741 296.963 296.648 291.175 302.002C289.294 303.739 287.123 305.186 284.518 306.488C294.214 306.778 300.581 307.646 301.883 308.949C302.318 309.527 302.318 309.961 302.173 310.106C301.449 311.843 293.78 312.132 268.166 311.843C248.63 316.039 225.911 315.026 223.306 313.579C222.727 313.29 222.727 312.711 222.727 312.566C222.872 311.987 223.451 311.553 226.2 311.119C233.725 310.106 250.222 310.251 266.14 310.396C266.719 310.396 267.443 310.396 268.166 310.396C271.639 309.672 274.967 308.804 278.006 307.646C257.602 307.357 225.766 308.514 191.47 311.409C163.686 313.724 130.403 315.46 106.526 316.039C106.526 316.184 106.526 316.184 106.526 316.329C106.526 317.197 106.526 317.92 91.3311 318.789C81.0567 319.223 67.0199 319.512 52.2595 319.512ZM78.1625 314.158C80.1884 314.447 84.6744 314.592 90.8969 314.592C87.4239 314.303 83.9509 313.869 81.0567 313.435C80.0437 313.724 78.886 313.869 78.1625 314.158ZM226.056 312.566C230.686 313.434 246.026 313.869 261.075 311.553C247.183 311.409 233.581 311.409 227.069 312.277C226.779 312.422 226.345 312.422 226.056 312.566ZM85.6874 305.475C81.4908 305.475 77.4389 306.778 75.5577 308.37C74.8342 308.948 74.5447 309.527 74.5447 309.817C74.6895 310.251 75.413 310.83 76.7154 311.119C77.7284 311.409 79.3202 311.698 81.2014 311.987C81.9249 311.843 82.7932 311.698 83.8062 311.553C87.2792 310.83 94.5147 309.527 94.6594 308.37C94.6594 308.37 94.6594 307.936 92.7782 307.067C90.4628 305.91 88.0027 305.475 85.6874 305.475ZM274.678 310.251C286.544 310.396 298.555 310.251 301.305 309.383C299.423 308.37 292.622 307.791 282.492 307.501C280.032 308.514 277.428 309.527 274.678 310.251Z",
    fill: "url(#paint6_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7366 297.373C33.1578 297.373 32.579 297.373 32.0001 297.373C14.635 296.65 11.8855 290.283 11.7408 289.993C11.5961 289.559 11.7408 289.27 12.1749 289.125C12.609 288.98 12.8985 289.125 13.0432 289.559C13.0432 289.704 15.7927 295.347 32.0001 296.071C48.497 296.794 53.8513 287.244 53.996 287.244C54.1407 286.954 54.5748 286.81 55.0089 286.954C55.2984 287.099 55.4431 287.533 55.2984 287.967C55.0089 288.112 49.6547 297.373 33.7366 297.373Z",
    fill: "url(#paint7_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4752 297.953C16.9503 297.953 12.0301 294.914 11.7407 294.769C11.4513 294.625 11.3066 294.046 11.4513 293.756C11.596 293.467 12.1748 293.322 12.4643 293.467C12.609 293.467 23.3175 299.979 37.0649 293.467C50.6676 286.955 50.3782 280.588 50.2335 280.588C50.2335 280.154 50.5229 279.864 50.957 279.864C51.3911 279.864 51.6806 280.154 51.6806 280.443C51.6806 280.733 52.2594 287.823 37.6437 294.769C32.7236 297.085 28.2376 297.953 24.4752 297.953Z",
    fill: "url(#paint8_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.092 283.337C106.092 283.337 84.6747 281.601 80.044 283.627C75.4133 285.652 77.2945 301.136 77.2945 301.136H158.332L187.563 275.233L106.092 283.337Z",
    fill: "#932F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.041 290.427C236.041 290.427 234.738 294.623 237.633 297.517L258.181 296.939L273.231 286.809L257.747 248.316L247.618 245.277L236.041 290.427Z",
    fill: "#932F31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.363 295.926C205.363 295.926 216.795 297.952 233.726 291.44C250.658 284.928 257.314 268.576 257.314 268.576C257.314 268.576 260.353 238.187 249.21 235.148C238.068 232.109 204.061 271.759 204.061 271.759L205.363 295.926Z",
    fill: "url(#paint9_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.05 189.566C114.05 189.566 112.169 177.7 107.538 175.819C102.908 173.938 85.8321 177.845 84.0955 191.448C82.359 205.05 90.1733 213.878 90.1733 213.878L114.05 189.566Z",
    fill: "url(#paint10_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.776 196.511C103.776 196.511 100.448 184.5 91.9098 183.053C83.5167 181.461 79.4648 200.852 90.1733 214.021L103.776 196.511Z",
    fill: "url(#paint11_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.151 297.518C273.81 300.991 259.628 299.544 259.628 299.544C259.628 299.544 256.734 295.492 257.747 292.598C258.76 289.704 264.114 282.758 263.68 280.008C263.101 277.259 256.589 276.101 253.406 269.444C250.222 262.788 249.933 245.133 249.933 245.133C249.933 245.133 234.304 266.695 213.177 276.535C213.177 276.535 213.177 276.535 213.177 276.68C212.887 278.272 210.282 294.479 200.732 299.833C190.747 305.622 139.23 304.898 139.23 304.898C139.23 304.898 135.033 294.334 140.532 289.848C140.532 289.848 146.61 289.125 170.053 282.758C193.496 276.391 200.732 245.278 200.732 245.278C200.732 245.278 209.414 245.423 218.386 238.766C227.358 232.254 232.423 223.137 244.723 219.52C256.879 216.047 269.035 220.533 276.704 232.399C284.229 244.265 279.019 265.393 280.467 269.3C281.335 271.76 282.927 273.786 283.94 275.522C284.518 276.391 284.953 277.259 284.953 277.982C284.808 279.864 282.637 294.045 278.151 297.518Z",
    fill: "url(#paint12_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.019 261.485L205.362 262.788C205.362 262.788 193.351 273.93 175.986 280.587C158.766 287.244 137.059 284.639 131.416 285.652C125.772 286.665 113.616 293.177 113.616 293.177C113.616 293.177 104.644 287.244 103.631 283.336C103.631 283.336 84.0957 282.468 72.6636 264.958L66.2964 267.129C66.2964 267.129 78.452 256.71 83.3721 241.081C88.2922 225.453 89.1605 214.599 91.7653 208.811C96.1066 199.405 122.299 182.04 134.744 181.461L131.271 176.686C131.271 176.686 164.844 186.092 176.71 197.234C188.721 208.666 195.377 245.423 212.019 261.485Z",
    fill: "url(#paint13_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.328 202.877C180.328 202.877 191.182 188.261 189.445 176.829C187.709 165.397 172.369 159.464 163.108 163.95C153.702 168.436 156.017 185.512 156.017 185.512C156.017 185.512 165.713 200.996 169.765 203.022C173.816 204.758 180.328 202.877 180.328 202.877Z",
    fill: "url(#paint14_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.87 185.368C155.87 185.368 154.712 167.134 163.25 165.543C171.788 163.951 176.998 177.264 175.695 187.394C174.393 197.379 169.617 202.878 169.617 202.878C169.617 202.878 167.157 203.891 155.87 185.368Z",
    fill: "url(#paint15_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.872 185.369C155.872 185.369 162.818 179.002 168.317 181.173C173.816 183.343 174.684 196.223 174.684 196.223L167.449 188.408C167.449 188.408 174.974 199.262 174.684 211.417C174.684 211.417 159.49 199.262 155.872 185.369Z",
    fill: "url(#paint16_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.776 196.51C103.776 196.51 87.4236 190.288 80.0435 199.405L95.238 200.418C95.238 200.418 85.3977 203.167 83.8059 208.666C82.0694 214.02 88.2919 222.848 88.2919 222.848C88.2919 222.848 90.1731 213.007 92.0544 208.811C93.7909 204.614 103.776 196.51 103.776 196.51Z",
    fill: "url(#paint17_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.364 262.788C205.219 262.933 205.219 262.933 205.074 263.078C204.351 263.656 202.614 265.248 200.009 267.129C200.009 267.129 200.009 267.129 199.865 267.129C194.655 271.037 186.262 276.536 175.988 280.443C158.767 287.099 137.061 284.495 131.417 285.507C125.773 286.52 113.618 293.032 113.618 293.032C113.618 293.032 104.646 287.099 103.633 283.192C103.633 283.192 84.0971 282.324 72.665 264.814C92.0561 268.432 95.9633 264.38 95.9633 264.38C110.29 264.525 122.59 259.604 122.59 259.604C168.897 270.458 205.364 262.788 205.364 262.788Z",
    fill: "url(#paint18_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.635 202.878C268.6 206.641 264.693 213.732 263.246 220.678C263.246 220.678 256.879 220.967 252.248 218.652C252.103 218.652 252.103 218.507 251.958 218.507C251.958 218.507 251.958 218.362 251.958 218.073C251.958 216.626 252.103 210.838 255.866 203.747C256.3 202.734 257.023 201.721 257.602 200.708C263.825 191.157 286.11 192.459 294.214 180.593C297.976 175.094 300.581 163.952 294.069 157.874C291.175 155.124 286.255 153.533 279.019 153.967C255.287 155.269 261.509 126.472 278.296 128.064C285.531 128.787 294.069 131.103 301.449 135.444C302.752 136.312 304.054 137.18 305.356 138.049C313.171 143.837 319.104 152.375 319.972 164.096C319.972 164.53 319.972 164.965 319.972 165.254C320.551 179.725 312.447 199.984 293.635 202.878Z",
    fill: "url(#paint19_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.214 158.018C291.175 155.269 286.399 153.677 279.019 154.111C255.287 155.414 261.509 126.616 278.296 128.208C285.531 128.932 294.069 131.247 301.449 135.588L305.356 138.193C310.132 156.282 294.792 157.874 294.214 158.018Z",
    fill: "url(#paint20_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6222 253.815C81.201 257.867 91.3307 262.787 96.2508 261.774C99.8686 261.05 105.802 259.314 105.946 246.001C106.091 232.687 99.7239 209.389 94.8037 208.81C90.0283 208.232 88.8707 227.912 86.4106 237.029C84.0952 246.001 80.3328 251.934 80.6222 253.815Z",
    fill: "url(#paint21_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.692 225.018C126.64 228.78 125.048 248.461 129.968 253.815C137.638 261.919 167.159 260.327 172.513 252.802C178.012 245.277 168.027 211.994 160.068 209.389C152.109 206.784 147.044 213.152 142.124 217.348C137.349 221.545 133.875 221.979 130.692 225.018Z",
    fill: "url(#paint22_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.075 237.753C127.075 237.753 127.654 228.926 132.284 225.163C136.915 221.256 142.414 221.111 146.611 217.783C149.071 215.757 152.688 210.547 158.043 209.824C163.686 209.1 169.33 222.558 169.33 222.558C169.33 222.558 166.002 208.087 156.885 207.219C151.675 206.785 146.755 214.31 140.243 218.651C133.731 222.992 131.706 222.558 129.101 226.61C126.351 230.517 127.075 237.753 127.075 237.753Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5562 236.884C86.5562 236.884 90.7527 212.718 94.6599 212.139C100.593 211.271 105.079 231.096 105.947 245.856C105.947 245.856 105.947 209.824 94.8046 208.666C92.634 208.521 89.8845 212.428 86.5562 236.884Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.658 243.543C160.934 236.308 155.58 227.77 147.187 225.31C138.938 222.85 132.571 227.191 130.69 231.677C128.664 236.163 128.519 249.766 137.057 255.699C144.437 260.908 162.96 257.001 161.658 243.543Z",
    fill: "url(#paint23_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.658 243.542C161.658 243.542 161.947 232.833 152.107 225.308C142.267 217.783 130.545 224.44 129.822 235.438C129.822 235.438 130.545 227.19 140.53 224.874C149.936 222.848 159.487 231.965 161.658 243.542Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.545 246.436C132.426 253.671 139.517 258.157 146.173 256.421C152.83 254.684 156.737 247.304 154.856 240.068C152.975 232.833 145.884 228.347 139.227 230.083C132.571 231.82 128.664 239.2 130.545 246.436Z",
    fill: "url(#paint24_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.834 246.87C132.57 253.527 138.938 257.578 145.015 255.987C151.093 254.395 154.566 247.738 152.975 241.082C151.238 234.425 144.871 230.373 138.793 231.965C132.57 233.557 129.097 240.213 130.834 246.87Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.079 248.895C161.079 248.895 159.487 255.551 150.081 258.156C140.675 260.905 134.452 253.381 134.452 253.381C134.452 253.381 140.096 259.169 149.213 257.577C158.185 255.985 161.079 248.895 161.079 248.895Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.712 254.831C154.712 254.831 151.818 247.595 147.477 246.438C147.477 246.438 144.727 248.174 140.675 249.332L143.135 257.87C143.28 257.725 150.371 260.908 154.712 254.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.081 238.477C150.515 239.924 151.962 240.793 153.265 240.359C154.712 239.924 155.58 238.477 155.146 237.175C154.712 235.728 153.265 234.86 151.962 235.294C150.66 235.583 149.792 237.03 150.081 238.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.588 263.801C122.588 263.801 123.746 262.354 122.877 260.907C122.877 260.907 107.393 264.814 96.8296 264.38C96.8296 264.38 99.2897 268.577 103.486 270.892L106.67 270.603C106.67 270.603 111.011 265.538 119.983 265.393L122.588 263.801Z",
    fill: "url(#paint25_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.023 260.907L125.338 258.447C125.338 258.447 118.682 249.909 106.092 253.961C106.092 253.961 98.7116 260.907 96.9751 264.236C96.9751 264.38 109.42 265.393 123.023 260.907Z",
    fill: "#FF9F30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.023 260.907C123.023 260.907 115.642 263.946 106.815 264.959C97.9879 265.972 96.6855 264.236 96.6855 264.236C96.6855 264.236 106.96 264.814 123.023 260.907Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.984 265.248C119.984 265.248 111.736 263.801 106.671 270.458C106.526 270.458 111.88 265.248 119.984 265.248Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1318 259.748C98.2766 259.748 98.2766 259.748 98.4213 259.604C100.447 258.88 101.894 257.578 102.907 255.697C104.933 252.224 105.512 247.159 104.788 242.239C104.644 241.081 104.354 239.923 104.21 238.91C103.486 235.727 102.328 233.556 101.026 232.109C99.4342 230.228 97.6977 229.504 96.2506 229.215C93.067 228.781 89.4493 234.424 88.4363 243.396C87.5681 252.513 92.054 261.63 98.1318 259.748Z",
    fill: "url(#paint26_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.644 250.776C104.644 250.776 105.802 237.897 100.448 231.964C95.0934 226.031 89.5945 235.003 89.0156 240.357C89.0156 240.357 90.8968 229.504 95.3828 227.188C95.2381 227.188 106.815 227.478 104.644 250.776Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4364 247.45C89.0152 254.685 92.6329 260.184 96.5401 259.895C100.447 259.605 103.052 253.527 102.473 246.292C101.894 239.056 98.2766 233.557 94.3695 233.847C90.4623 234.136 87.8575 240.214 88.4364 247.45Z",
    fill: "url(#paint27_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2925 247.449C88.8713 253.816 92.0549 258.736 95.5279 258.591C99.001 258.302 101.316 252.948 100.882 246.436C100.303 240.069 97.1197 235.148 93.6467 235.293C90.1737 235.438 87.8583 240.937 88.2925 247.449Z",
    fill: "#75272C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.303 243.977C100.592 244.845 101.46 245.424 102.473 245.279C103.341 244.99 103.92 244.122 103.776 243.109C103.486 242.24 102.618 241.662 101.605 241.806C100.592 242.096 100.013 242.964 100.303 243.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2889 258.881L94.6582 253.237L96.25 250.777L103.775 252.659C103.775 252.659 103.196 257.579 99.2889 258.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.04 279.721C102.04 279.721 106.671 277.84 113.328 277.55C119.984 277.405 123.313 276.103 127.075 274.511C130.838 272.775 133.732 265.395 133.732 265.395L134.6 265.829C134.6 265.829 129.825 281.602 124.47 282.181C119.116 282.904 116.656 278.997 111.881 278.853C106.961 278.708 103.343 281.313 103.343 281.313C103.343 281.313 101.896 281.457 102.04 279.721Z",
    fill: "url(#paint28_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.548 265.104C130.548 265.104 135.468 264.959 139.23 268.722C139.23 268.722 138.796 265.683 135.902 263.946C133.008 262.499 130.548 265.104 130.548 265.104Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.378 278.126C117.378 278.126 124.324 277.258 126.929 275.666C130.547 273.496 131.56 270.746 131.56 270.746C131.56 270.746 129.534 277.403 125.916 279.718C122.443 282.323 117.378 278.126 117.378 278.126Z",
    fill: "url(#paint29_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9743 265.537C96.9743 265.537 91.7648 275.522 101.026 280.587L103.052 281.455L103.631 283.481C103.631 283.481 96.6849 283.047 88.8706 279.285C88.8706 279.285 90.173 269.878 96.9743 265.537Z",
    fill: "url(#paint30_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.033 181.605C135.033 181.605 116.51 194.195 114.195 229.215C114.195 229.215 108.551 211.849 115.497 188.841C115.497 188.696 128.231 179.579 135.033 181.605Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.715 180.738C143.715 180.738 126.205 189.566 123.601 215.613C123.601 215.613 140.676 192.026 154.858 184.79L143.715 180.738Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.854 192.169C109.854 192.169 105.368 200.707 107.683 213.297C107.683 213.297 100.882 204.903 101.75 198.102C101.895 198.102 107.539 192.748 109.854 192.169Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.724 201.867C99.724 201.867 100.882 204.182 117.234 203.748C133.586 203.314 152.109 189.856 152.109 189.856C152.109 189.856 144.584 180.884 126.929 185.225C109.275 189.567 99.0005 202.735 99.0005 202.735L99.724 201.867Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.798 232.544C194.798 232.544 194.943 244.121 184.958 251.791C174.973 259.605 163.975 262.21 152.109 260.908C152.109 260.908 169.474 263.512 181.34 248.897C193.062 234.426 186.984 213.877 186.984 213.877L194.798 232.544Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.27 240.357C198.27 240.357 200.875 249.619 194.797 256.275C188.575 263.077 149.648 264.379 149.648 264.379C149.648 264.379 181.195 267.563 205.506 262.932L213.031 261.919C213.031 261.919 202.756 253.381 198.27 240.357Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.635 202.879C268.6 206.641 264.693 213.732 263.246 220.678C263.246 220.678 256.879 220.968 252.248 218.652L251.958 218.074C251.958 216.626 252.103 210.838 255.866 203.747C255.866 203.747 263.969 211.706 292.477 199.551C319.683 187.974 319.683 167.28 319.827 165.544C320.551 179.725 312.447 199.985 293.635 202.879Z",
    fill: "#CE777C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.533 244.121C207.533 244.121 219.544 246.726 225.622 257.868C225.622 257.868 227.648 248.896 216.216 240.214C216.216 240.359 210.427 243.542 207.533 244.121Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.412 237.175C220.412 237.175 226.779 239.924 228.516 245.279C228.516 245.279 229.384 237.175 226.635 231.531C226.779 231.531 222.583 235.583 220.412 237.175Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.252 228.202C230.252 228.202 238.646 227.045 245.592 242.529C245.592 242.529 246.46 228.637 237.922 222.414C237.922 222.559 233.725 224.874 230.252 228.202Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.344 285.506C159.344 285.506 176.709 287.677 181.919 296.07C181.919 296.07 182.787 289.268 171.5 282.322L159.344 285.506Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.367 277.404C183.367 277.404 191.471 282.469 192.484 293.322C192.484 293.322 195.523 283.048 190.747 273.353L183.367 277.404Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.943 270.747C194.943 270.747 204.494 269.589 209.125 275.088C209.125 275.088 207.823 268.142 203.626 264.38L194.943 270.747Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.02 237.609C279.02 237.609 273.231 254.54 251.814 259.75C251.814 259.75 273.521 257.435 280.756 247.884C280.612 247.739 280.322 241.082 279.02 237.609Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.756 253.961C280.756 253.961 279.743 261.92 269.179 267.13C269.179 267.13 277.428 266.84 280.322 262.644L280.756 253.961Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.747 200.707C257.747 200.707 270.047 196.799 275.98 202.588C275.98 202.588 275.836 197.089 264.404 195.497C264.404 195.497 259.918 196.799 257.747 200.707Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.888 189.999C279.888 189.999 286.544 190.144 288.57 199.695C288.57 199.695 293.925 193.617 288.57 185.947C288.715 185.947 282.782 190.144 279.888 189.999Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.463 183.921C291.463 183.921 302.461 183.198 307.96 196.077C307.96 196.077 313.169 184.934 296.962 175.528C296.962 175.528 294.212 181.896 291.463 183.921Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.975 165.398C297.975 165.398 304.198 159.754 317.511 165.398C317.511 165.398 311.289 158.162 295.081 159.03C295.081 158.886 297.831 161.78 297.975 165.398Z",
    fill: "#9D3D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.117 237.754C247.907 240.937 250.078 263.078 256.735 269.734C263.391 276.246 273.376 265.972 275.981 258.881C278.586 251.791 267.877 228.782 253.117 237.754Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.519 304.899C150.519 304.899 149.506 295.204 151.966 293.322C154.426 291.296 161.661 293.322 161.661 293.322C161.661 293.322 154.281 292.309 152.4 294.625C150.663 297.085 150.519 304.899 150.519 304.899Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.27 304.898C142.27 304.898 138.363 295.926 140.823 292.308C143.138 288.691 149.071 289.125 149.071 289.125C149.071 289.125 143.428 289.125 141.546 293.177C139.52 297.373 142.27 304.898 142.27 304.898Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.177 276.824C212.887 278.416 210.282 294.623 200.732 299.978C190.747 305.766 139.23 305.043 139.23 305.043C139.23 305.043 135.033 294.479 140.532 289.993C140.532 289.993 140.532 294.479 152.109 297.518C163.686 300.557 192.338 305.332 201.31 296.215C209.848 287.677 212.887 277.982 213.177 276.824Z",
    fill: "url(#paint31_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.366 299.834C261.366 299.834 259.774 295.203 260.642 292.743C261.51 290.283 263.247 288.691 263.247 288.691C263.247 288.691 260.642 292.309 261.366 299.834Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.363 299.544C272.363 299.544 269.324 296.939 269.468 294.19C269.468 291.44 271.06 288.257 271.06 288.257C271.06 288.257 268.6 295.058 273.665 299.399L272.363 299.544Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.15 297.518C273.809 300.992 259.628 299.544 259.628 299.544C259.628 299.544 256.733 295.493 257.746 292.598C257.746 292.598 266.574 295.348 274.967 290.862C281.334 287.389 283.215 278.996 283.649 275.378C284.228 276.246 284.662 277.114 284.662 277.838C284.807 279.864 282.636 294.045 278.15 297.518Z",
    fill: "url(#paint32_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.532 289.847C140.532 289.847 144.729 294.767 159.344 296.07C173.96 297.372 185.826 287.532 186.839 284.782C187.852 282.033 182.209 279.862 179.314 280.586C176.275 281.309 158.476 286.664 140.532 289.847Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.747 292.744C257.747 292.744 266.43 295.204 273.665 291.441C280.901 287.679 282.203 279.575 282.203 278.851C282.203 278.128 270.916 277.115 267.153 278.851C263.391 280.588 257.747 292.744 257.747 292.744Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.614 131.103C263.102 133.563 267.877 143.258 285.676 148.613C303.476 153.967 316.5 158.598 318.381 156.282C320.117 153.822 294.359 121.841 269.614 131.103Z",
    fill: "#FFC763"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.863 267.274C194.654 271.182 186.26 276.681 175.986 280.588C158.766 287.244 137.059 284.64 131.415 285.653C125.772 286.665 113.616 293.177 113.616 293.177C113.616 293.177 126.929 282.903 137.493 281.167C147.334 279.719 179.748 281.022 199.863 267.274Z",
    fill: "url(#paint33_linear_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7546 284.929C79.7546 284.929 88.8713 284.206 95.2385 287.389C101.461 290.428 103.632 301.137 103.632 301.137H77.2946C77.2946 301.137 74.9792 287.968 79.7546 284.929Z",
    fill: "url(#paint34_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8041 300.847C94.8041 300.847 92.3441 289.125 95.2382 287.244C95.2382 287.389 90.3181 289.704 94.8041 300.847Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6351 301.136C81.6351 301.136 79.1751 290.572 81.6351 287.388C84.0952 284.205 88.0023 284.783 88.0023 284.783C88.0023 284.783 81.6351 283.915 79.8986 287.822C78.1621 291.729 81.0563 301.136 81.0563 301.136H81.6351Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.22 286.375C261.075 286.375 260.931 286.375 260.786 286.23C258.615 284.639 257.602 282.613 258.326 280.731C259.484 277.258 265.417 275.088 273.231 275.232C279.743 275.377 283.65 276.535 284.952 278.416C285.676 279.574 285.242 280.442 285.242 280.587C285.097 281.021 284.663 281.165 284.229 280.876C283.939 280.731 283.65 280.297 283.795 280.008C283.795 280.008 283.939 279.574 283.65 279.14C283.216 278.416 281.19 276.824 273.231 276.679C264.983 276.535 260.497 278.85 259.773 281.165C259.339 282.468 260.062 283.915 261.799 285.073C262.088 285.362 262.233 285.796 261.944 286.086C261.654 286.375 261.509 286.375 261.22 286.375Z",
    fill: "url(#paint35_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.046 294.046C280.901 294.046 280.757 294.046 280.612 293.901C280.322 293.612 280.322 293.177 280.467 292.888C282.927 289.994 283.217 287.244 281.046 284.784C276.849 280.154 265.996 278.562 262.234 281.022C260.642 282.18 260.787 285.797 261.076 287.244C261.076 287.679 260.931 287.968 260.497 288.113C260.063 288.113 259.774 287.968 259.629 287.534C259.484 286.955 258.761 281.745 261.51 280.009C266.141 276.97 277.862 279.141 282.204 283.916C284.808 286.81 284.664 290.428 281.625 293.901C281.48 293.901 281.191 294.046 281.046 294.046Z",
    fill: "url(#paint36_radial_83_7106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.418 273.785C254.418 273.785 247.906 261.485 249.932 245.277C249.932 245.277 249.788 262.932 255.142 272.483L254.418 273.785Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.01 219.954C256.01 219.954 275.257 227.045 279.743 240.358C279.743 240.358 277.717 227.479 263.39 220.822C263.39 220.678 258.904 220.822 256.01 219.954Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.361 295.926C205.361 295.926 218.53 296.07 231.554 291.44C244.433 286.809 251.09 278.705 251.09 278.705C251.09 278.705 238.934 298.241 205.361 295.926Z",
    fill: "#BD4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.419 263.512C109.419 263.512 116.365 260.039 118.826 261.92C118.826 261.92 115.353 263.801 109.419 263.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2764 265.537C98.2764 265.537 99.5788 268.431 103.196 270.457C103.196 270.457 103.92 267.274 98.2764 265.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.639 244.844C204.639 244.844 211.295 247.593 225.766 241.66C240.093 235.727 246.604 223.427 245.447 222.558C244.289 221.545 238.356 220.967 232.712 226.031C227.213 231.096 218.675 244.12 204.639 244.844Z",
    fill: "#FFC763"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6214 282.9) scale(21.4979 21.4979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9918 297.367) scale(17.9791 17.9791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9633 299.329) scale(16.6542 16.6542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3589 287.864) scale(20.6152 20.6152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7598 290.185) scale(18.3374 18.3374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#42D696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00695B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8757 290.497) scale(16.6076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#42D696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00695B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.303 303.066) scale(107.912 107.912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_83_7106",
    x1: 11.6201,
    y1: 291.979,
    x2: 55.292,
    y2: 291.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00695B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#42D696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_83_7106",
    x1: 11.3746,
    y1: 288.841,
    x2: 51.7735,
    y2: 288.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00695B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#42D696"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.916 265.528) scale(28.7902)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_83_7106",
    x1: 99.0326,
    y1: 214.004,
    x2: 99.0326,
    y2: 175.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.7719 198.47) scale(13.0596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.101 225.26) scale(56.081 56.081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.219 206.364) scale(65.2942 65.2942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_83_7106",
    x1: 172.653,
    y1: 203.676,
    x2: 172.653,
    y2: 162.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#592930"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.95 184.098) scale(15.0333 15.0333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.35 196.031) scale(12.7343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.9162 208.702) scale(13.0836 13.0836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.089 276.624) scale(48.3715 48.3715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC381"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.119 135.343) scale(55.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_83_7106",
    x1: 263.407,
    y1: 143.031,
    x2: 306.282,
    y2: 143.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA252"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.3189 235.281) scale(20.8293 20.8293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.589 233.94) scale(24.4465 24.4465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFEC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_83_7106",
    x1: 149.604,
    y1: 257.544,
    x2: 140.933,
    y2: 224.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.747 250.758) rotate(165.312) scale(12.5953 13.6684)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.458 265.248) rotate(166.403) scale(9.74646 9.74645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_83_7106",
    x1: 98.3049,
    y1: 259.786,
    x2: 94.7701,
    y2: 229.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.5266 254.056) rotate(175.272) scale(7.0389 13.0667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FFC710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE4B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.242 273.846) scale(12.9454 12.9454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#9A4327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    stopColor: "#8B3B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_83_7106",
    x1: 124.533,
    y1: 280.611,
    x2: 124.533,
    y2: 270.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#FBC9CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_83_7106",
    x1: 96.3006,
    y1: 283.456,
    x2: 96.3006,
    y2: 265.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_83_7106",
    x1: 175.442,
    y1: 304.994,
    x2: 175.442,
    y2: 276.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#AC6393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_83_7106",
    x1: 271.127,
    y1: 299.938,
    x2: 271.127,
    y2: 275.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#AC6393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_83_7106",
    x1: 156.829,
    y1: 293.326,
    x2: 156.829,
    y2: 267.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#E08893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.5981 288.982) scale(10.3825 10.3825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171145,
    stopColor: "#FF8E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6543"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.713 280.797) scale(10.4104 10.4104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_83_7106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.695 286.245) scale(10.2803 10.2803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#008B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004F53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_7106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTigerExcited);
export default __webpack_public_path__ + "static/media/tiger_excited.83bc4b4cc329ce43242bf41db4d2befc.svg";
export { ForwardRef as ReactComponent };